// extracted by css-extract-rspack-plugin
export default {"details":"details-fYSxLV"};